import React from 'react';

import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { Info, X } from 'lucide-react';

import Button from '../common/Button';

type AlertDialogProps = {
  open: boolean;
  content?: string;
  handleClose?: () => void;
};

const WaitingModelOutputDialog = ({
  open,
  handleClose,
  content,
}: AlertDialogProps) => (
  <Dialog
    open={open}
    onClose={handleClose}
    aria-labelledby="Title"
    aria-describedby="alertContent"
  >
    <DialogTitle id="alertTitle">
      <div className="w-full flex justify-between">
        <div className="flex gap-2 items-center">
          <Info color="#2196F3" />
          <h2 className="font-semibold text-xl">Calculation in Progress</h2>
        </div>
        {handleClose && (
          <X color="#666" className="cursor-pointer" onClick={handleClose} />
        )}
      </div>
    </DialogTitle>
    <DialogContent id="alertContent">
      <div className="flex flex-col">
        <div className="min-w-[400px] space-y-4 text-[#666]">
          <p>
            {content ??
              "The calculation is currently running... ⏳ and we'll notify you when it's complete."}
          </p>
        </div>
        <div className="flex justify-end">
          {handleClose && (
            <Button variant="contained_blue" onClick={handleClose}>
              Ok
            </Button>
          )}
        </div>
      </div>
    </DialogContent>
  </Dialog>
);

export default WaitingModelOutputDialog;
